import { useLocation } from "react-router-dom";
import { SidebarMenuItem } from "../types";

export function useSidebarSelection(menuItem: SidebarMenuItem): boolean {
  const location = useLocation();
  const pathname = location.pathname;

  if (menuItem.href) {
    const linkPath = menuItem.href.split("?")[0];
    // Match exact path or paths that start with the link path followed by /
    return pathname === linkPath || pathname.startsWith(linkPath + "/");
  }

  return false;
}

